import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SearchBar from '../components/SearchBar';
import FeaturedProducts from '../components/FeaturedProducts';
import Services from '../components/Services';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <Header />
      <Hero />
      <SearchBar />
      <FeaturedProducts />
      <Services />
      <CTA />
      <Footer />
    </div>
  );
};

export default Home;
